import React, { Component } from 'react';
import Formulario from './FormSeleccionarPeriodo';


class SeleccionarPeriodo extends Component{

    render(){
        const { listarPeriodos, periodos, paisList, pais } = this.props;
        return(
            <Formulario
                listarPeriodos = {listarPeriodos}
                periodos = {periodos}
                paisList = {paisList}
                pais = {pais}
            />
           
        );
    } 
}

export default SeleccionarPeriodo;